import { useQuery } from "@tanstack/react-query";
import { get } from "../../api/client";

export const STUDENT_CERTIFICATE_KEY = {
  STUDENT_CERTIFICATES: "STUDENT_CERTIFICATES",
  CERTIFICATES_LIST: "CERTIFICATES_LIST",
};

// Fetch certificates for a single student
export const useGetStudentCertificates = ({
  studentId,
}: {
  studentId: number;
}) =>
  useQuery(
    [STUDENT_CERTIFICATE_KEY.STUDENT_CERTIFICATES, studentId],
    () => get({ url: `api/v1/students/${studentId}/certificate` }),
    {
      enabled: !!studentId,
    },
  );

// Fetch certificates for multiple students (for bulk management page)
export const useGetCertificatesList = ({
  page = 1,
  filters = {},
}: {
  page?: number;
  filters?: {
    classId?: number | null;
    branchId?: number | null;
    studentName?: string;
  };
}) => {
  const params: any = {
    page,
  };

  if (filters.classId) {
    params.classId = filters.classId;
  }

  if (filters.branchId) {
    params.branchId = filters.branchId;
  }

  if (filters.studentName) {
    params.studentName = filters.studentName;
  }

  return useQuery(
    [STUDENT_CERTIFICATE_KEY.CERTIFICATES_LIST, page, filters],
    () => get({ url: "api/v1/students/certificates", params }),
  );
};
